import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const ContractorForm = ({
  contractorForm,
  handleChange,
  handleSubmit,
  handleCancel,
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Name *</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={contractorForm.name}
              onChange={handleChange}
              placeholder="Enter contractor name"
              maxLength={50}
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Contact Number *</Form.Label>
            <Form.Control
              type="tel"
              name="contact_number"
              value={contractorForm.contact_number}
              onChange={handleChange}
              placeholder="Enter contact number"
              maxLength={15}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>

        <Button type="submit" variant="primary">
          {contractorForm.id ? "Update" : "Add"}
        </Button>
      </div>
    </Form>
  );
};

export default ContractorForm;